import dayjs from 'dayjs';
import { ContactCaptureType } from '../types';

export const CONTACT_CAPTURE_PAGE_SIZE = 25;

export const CONTACT_CAPTURE_TYPE_LABELS: Record<ContactCaptureType, string> = {
  popup: 'Popup',
  inline: 'Embed',
};

export const CONTACT_CAPTURE_TYPES = Object.keys(CONTACT_CAPTURE_TYPE_LABELS) as ContactCaptureType[];

/** Matches the `YYYY-MM-DD - <type>` default the campaign builder gives new campaigns. */
export const buildDefaultContactCaptureName = (): string =>
  `${dayjs().format('YYYY-MM-DD')} - Contact Capture`;

export const getConversionRate = (views: number, contacts: number): string => {
  if (!views) return '0.0%';
  return `${((contacts / views) * 100).toFixed(1)}%`;
};

export const getErrorMessage = (error: unknown, fallback: string): string => {
  if (error instanceof Error && error.message) return error.message;
  return fallback;
};
